import { render } from "./HighlightBadge.vue?vue&type=template&id=180f5bc8&scoped=true"
import script from "./HighlightBadge.vue?vue&type=script&lang=js"
export * from "./HighlightBadge.vue?vue&type=script&lang=js"

import "./HighlightBadge.vue?vue&type=style&index=0&id=180f5bc8&scoped=true&lang=scss"

import exportComponent from "/var/www/production/releases/343/listings.jumpfeed.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-180f5bc8"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
